import * as React from "react";
import { Spinner } from "react-bootstrap";

interface State {
  component: React.ComponentType | null;
}

/**
 * Wrapper to allow deferred component loading until mounted
 * @param importComponent
 */
export default function asyncComponent(importComponent: any) {
  class AsyncComponent extends React.Component {
    state: State;

    constructor(props: object) {
      super(props);

      this.state = {
        component: null,
      };
    }

    async componentDidMount() {
      const { default: component } = await importComponent();

      this.setState({ component });
    }

    render() {
      const { component: Component }: State = this.state;

      return Component ? (
        <Component {...this.props} />
      ) : (
        <div
          className="d-flex justify-content-center align-items-stretch"
          style={{ height: "90vh" }}
        >
          <div className="my-auto">
            <Spinner animation="border" role="status" variant="primary" />
          </div>
        </div>
      );
    }
  }

  return AsyncComponent;
}
